import { render, staticRenderFns } from "./pangolinData.vue?vue&type=template&id=4cb2b99a&"
import script from "./pangolinData.vue?vue&type=script&lang=js&"
export * from "./pangolinData.vue?vue&type=script&lang=js&"
import style0 from "./pangolinData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb2b99a')) {
      api.createRecord('4cb2b99a', component.options)
    } else {
      api.reload('4cb2b99a', component.options)
    }
    module.hot.accept("./pangolinData.vue?vue&type=template&id=4cb2b99a&", function () {
      api.rerender('4cb2b99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/pangolinData.vue"
export default component.exports